<template>
  <div>
    <BModal
      id="modalClaimsDoc"
      centered
      title="Документы"
      ok-variant="info"
      ok-title="Да"
      cancel-title="Отмена"
      hide-footer
      responsive
      size="xl"
      no-close-on-backdrop
    >
      <div class="text-right">
        <b-button
          variant="primary"
          @click="openDocAddModal"
        >
          <feather-icon
            icon="PlusIcon"
          />
          Добавить документы
        </b-button>
      </div>
      <BTable
        class="my-2"
        :items="docvalue.results"
        :fields="getFields"
        show-empty
        empty-text="Нет данных"
      >
        <template #cell(file)="props">
          <div class="d-flex flex-wrap">
            <b-button
              v-for="(t, index) in props.item.files"
              :key="index"
              v-b-tooltip.hover.v-primary
              size="sm"
              :title="props.item.file_title"
              variant="outline-primary"
              class="mr-1 mb-1 position-relative"
              @click.stop="downloadImage(t)"
            >
              <b-badge
                variant="danger"
                class="bbg_t"
                @click.stop="deleteFileData(t.id)"
              >
                x
              </b-badge>
              <feather-icon icon="FileIcon" />
              {{ t.file_title }}
            </b-button>
          </div>
        </template>
        <template #cell(actions)="props">
          <BButton
            class="p-50 mr-1"
            variant="warning"
            @click="editDocModal(props.item)"
          >
            <feather-icon
              icon="EditIcon"
            />
          </BButton>
          <BButton
            class="p-50"
            variant="danger"
            @click="$emit('deleteDataDocument', props.item.id)"
          >
            <feather-icon icon="XIcon" />
          </BButton>
        </template>
        <template #cell(tags)="props">
          <div
            v-for="(item, index) in props.item.tags"
            :key="index"
          >
            <b-badge variant="success">
              {{ item.name }} {{ " " }}
            </b-badge>
          </div>
        </template>
        <!-- <template #cell(title)="props">
          <span v-if="props.item.title">
            {{ props.item.title }}
          </span>
        </template> -->
        <template #cell(title)="props">
          <span v-if="props.item.title !== 'null'">{{ props.item.title }}</span>
        </template>
        <template #cell(comment)="props">
          <span v-if="props.item.comment !== 'null'">{{ props.item.comment }}</span>
        </template>
      </BTable>
      <BCPagination
        :count="docvalue.count"
        @input="onRefreshPagination"
      />
    </BModal>

    <addEditClaimsDocModal
      :type="type"
      :form-data="formData"
      :edit-doc="editDoc"
      :additional1="additional1"
      @createDoc="$emit('createDoc')"
      @editDocuments="editDocuments"
      @hideModal="$emit('hideModal')"
    />

    <modalFileSecond
      :file-data="fileData"
    />
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BTable,
  VBTooltip,
  BBadge,
} from 'bootstrap-vue'
import addEditClaimsDocModal from '@/modules/claimsLitigation/claimsModal/doc/addEditClaimsDocModal.vue'
import modalFileSecond from '@/components/casesFileModal/modalFileSecond.vue'
import BCPagination from '@/components/BCPagination.vue'
import { mapActions } from 'vuex'
import areYouSure from '@/mixins/areYouSure'

export default {
  name: 'TheDocModal',
  components: {
    BModal,
    BButton,
    BTable,
    addEditClaimsDocModal,
    modalFileSecond,
    BCPagination,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [areYouSure],
  props: {
    docvalue: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
    additional1: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      fileData: {},
      fields: [
        {
          label: 'Дата создания',
          key: 'created_date',
          sortable: true,
        },
        {
          label: 'Дата документа',
          key: 'date_document',
        },
        {
          label: 'Вид действия',
          key: 'action_type.name',
          additional: true,
        },
        {
          label: 'Вид документ',
          key: 'tags',
        },
        {
          label: 'Файлы',
          key: 'file',
        },
        {
          label: 'Полезная информация',
          key: 'title',
        },
        {
          label: 'Комментарий',
          key: 'comment',
        },
        {
          label: 'Действия',
          key: 'actions',
        },
      ],
      editDoc: {},
    }
  },
  computed: {
    getFields() {
      if (this.additional1) {
        return this.fields
      }
      const arr = this.fields.filter(item => !item.additional)
      return arr
    },
  },
  methods: {
    ...mapActions('cases', ['DELETE_DEBT_DOCUMENT_FILE_DATA']),

    deleteFileData(id) {
      this.$_showAreYouSureModal()
        .then(e => {
          if (e) {
            this.DELETE_DEBT_DOCUMENT_FILE_DATA(id)
              .then(() => {
                this.$emit('docRefresh')
              })
          }
        })
    },

    onRefreshPagination(data) {
      this.$emit('docRefresh', data)
    },

    downloadImage(t) {
      this.fileData = t
      this.$nextTick(() => {
        this.$bvModal.show('modalFileSecond')
      })
    },

    editDocuments() {
      this.$emit('editDocuments', this.editDoc.id)
      this.$emit('hideModal')
    },

    openDocAddModal() {
      this.editDoc = {}
      this.$emit('hideModal')
      this.$nextTick(() => {
        this.$bvModal.show('addEdiClaimstDoc')
      })
    },

    editDocModal(item) {
      this.editDoc = item
      this.$nextTick(() => {
        this.$bvModal.show('addEdiClaimstDoc')
      })
    },
  },
}
</script>

<style>
.file__w{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 150px;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.bbg_t {
  position: absolute!important;
  right: -8px!important;
  top: -8px!important;
}
</style>
